/* global google */
/* global googleMapsUrl */

mapCoordinatesDirective.$inject = ['loadScript'];

function mapCoordinatesDirective(loadScript) {

  return {
    template: require('html/templates/mapCoordinates'),
    restrict: 'E',
    replace: true,

    scope: {
      countryCode: '=',
      city: '=',
      address: '=',
      onSave: '='
    },

    link: function(scope) {

      scope.markerPlaced = function(address, position) {
        scope.newAddress = address;
        scope.position = position;
        scope.$apply();
      };

      scope.save = function() {
        scope.onSave(scope.position.lat(), scope.position.lng(), scope.newAddress);
      };

      loadScript
        .load(googleMapsUrl)
        .then(function() {
          initializeMap(scope.countryCode, scope.city, scope.address, scope.markerPlaced);
        });
    }

  };

}

module.exports = mapCoordinatesDirective;


function initializeMap(countryCode, city, address, markerPlaced) {

  var mapOptions = {
    disableDefaultUI: true,
    keyboardShortcuts: false,
    clickableIcons: false,
    draggableCursor: 'pointer',
    tilt: 0,
    center: { // Oslo
      lat: 59.916600,
      lng: 10.729400
    },
    zoom: 12,
    zoomControl: true,
    zoomControlOptions: {
      position: google.maps.ControlPosition.TOP_RIGHT
    }
  };

  var map = new google.maps.Map(document.getElementById('map'), mapOptions);
  var marker;
  var timer;

  getCenter(countryCode, address, function(location, address, isAddress, searchAgain) {
    if (searchAgain) {
      // Try again, now only with city
      getCenter(countryCode, city, function(location) {
        map.setCenter(location);
      });
    } else {
      map.setCenter(location);
      if (isAddress) {
        map.setZoom(16);
        addMarker(location);
        markerPlaced(address, location);
      }
    }
  });

  google.maps.event.addListener(map, 'click', function(event) {
    timer = window.setTimeout(function() {
      addMarker(event.latLng);
      getPlace(event, markerPlaced);
    }, 200);
  });

  google.maps.event.addListener(map, 'dblclick', function() {
    window.clearTimeout(timer);
  });

  var addMarker = function(position) {
    if (marker) {
      google.maps.event.clearListeners(marker, 'dragend');
      marker.setMap(null);
    }

    marker = new google.maps.Marker({
      map: map,
      position: position,
      draggable: true,
      crossOnDrag: false
    });

    google.maps.event.addListener(marker, 'dragend', function(event) {
      getPlace(event, markerPlaced);
    });
  };

}

function getPlace(event, callback) {
  geocode({
    location: event.latLng
  }, function(result) {
    callback(removeCountry(result), event.latLng);
  });
}

function getCenter(countryCode, address, callback) {
  geocode({
    address: address,
    componentRestrictions: {
      country: countryCode
    }
  }, function(result) { // successCallback
    var isAddress = result.types.some(function(type) {
      return type === 'street_address' || type === 'route';
    });
    var searchAgain = result.types.some(function(type) {
      return type === 'country'; // If the result is of type "whole country", we want to search again
    });
    callback(result.geometry.location, removeCountry(result), isAddress, searchAgain);
  }, function() { // emptyResultCallback
    // Order a new call when result is empty
    callback(null, null, false, true);
  });
}

function geocode(request, successCallback, emptyResultCallback) {
  new google.maps.Geocoder().geocode(request, function(results, status) {
    if (status === google.maps.GeocoderStatus.OK) {
      successCallback(results[0]);
    } else if (status === google.maps.GeocoderStatus.ZERO_RESULTS) {
      emptyResultCallback();
    }
  });
}

function removeCountry(address) {
  return address.formatted_address.replace(/, \w+$/, '');
}



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/directives/mapCoordinates.js
 ** module id = 146
 ** module chunks = 1
 **/